module.exports = {"baseUrl":"https://portal-static.static-origin.syn-cdn.com","link":"/"}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/logo-widget/config/default/config.json
// module id = 439
// module chunks = 9 10 12